/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { RestService } from "./rest-service";
import { Url_Base } from "app/rest-constants";

/**
 * Service used to retrieve System Settings from the backend.
 * This is done since it doesn't seem possible to retrieve any
 * System Environment Variables from the Server hosting the 
 * Angular App into the application,  
 * 
 * Example: 
 *   Each customer has a link to their WOW Reports, that URL is different
 *   for each customer, so this needs to be able to be a setting somehow.
 */
@Injectable()
export class SystemSettingsService {

  constructor(
    private restService: RestService
  ) { }

  /**
   * Gets / Returns the URL to use for the WOW Reports Link
   */
  public getWowReportsLink(): Promise<String> {
    const callUrl = `${Url_Base}/system-settings/wow-report-link`;
    return this.restService.get<String>(callUrl, 'text');
  }

}
